export const UPLOAD_API = "/common/upload_file"
export const LOGIN_API = "/auth/login"
export const FETCH_ME = "/auth/me"
export const FORGET_PW_API = "/auth/forget-pw"
export const CHECK_PHONE_EXIST_API = "/common/check_phone_exist"
export const REQUEST_OTP_API = "/common/request_otp"
export const VERIFY_OTP_API = "/common/verify_otp"
export const RESET_PW_API = "/auth/forgot_password"
export const CHANGE_PW_API = "/change_password"
export const MEMBERSHIP_PLAN_API = "/membership_plans"
